import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {

  currentTitle$ = new BehaviorSubject<string>('TORCH');
  defaultTitle = 'TORCH | TechOps Reliability and Component Health';

  constructor(private titleService: Title) {
    this.currentTitle$.subscribe(title => this.titleService.setTitle(title));
  }


  set title(newValue: string) {
    this.currentTitle$.next(`TORCH | ${newValue}`);
  }

  get title(): string {
    return this.currentTitle$.value
  }

  public reset(): void {
    this.currentTitle$.next(this.defaultTitle);
  }
}
